import { render, staticRenderFns } from "./EmployeePFSummery.vue?vue&type=template&id=06d32727"
import script from "./EmployeePFSummery.vue?vue&type=script&lang=js"
export * from "./EmployeePFSummery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports